module.exports = __webpack_public_path__ + "img/horeca-logo.60dca82b.png";